export const ROUTES = {
  // Absolute routes (with leading slash)
  LOGIN: '/login',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  CREATE_NEW_WEBSITE: '/create-new-website',
  BUILDER_TEST: '/builder-test',
  BUILDER: '/builder',
  NOT_FOUND: '/not-found',
  ENTRY: '/',

  // Relative routes (nested under /builder/:landingPageID/:interfaceId) - no leading slash
  BUILDER_EDITOR: 'editor',
  BUILDER_TEMPLATE_PREVIEW: 'template-preview',
  BUILDER_SETTINGS: 'settings',
  BUILDER_PUBLISH: 'publish',
};
